import Typography from "components/common/Typography";
import { Checkbox, Space } from "antd";
import { FormattedMessage } from "react-intl";
import VenueSelect from "components/data/VenueSelect";
import { Box } from "components/styles";

import * as Styled from "./styles";
import { useEmbedForm } from "./hooks";

const Embed = () => {
  const { embedScript, venueCheckboxes, venueSelect } = useEmbedForm();

  return (
    <Space direction="vertical">
      <Typography.Paragraph>
        <FormattedMessage defaultMessage="Select Which Venues you want populated on the calendar embed" />
      </Typography.Paragraph>
      <VenueSelect {...venueSelect} />
      <Space direction="vertical">
        {venueCheckboxes.map((checkboxProps) => (
          <Checkbox {...checkboxProps} />
        ))}
      </Space>
      <Box mt="1rem">
        <Typography.Paragraph>
          <FormattedMessage defaultMessage="Embed this snippet of JavaScript into any website that you’d like to market your events on" />
        </Typography.Paragraph>
      </Box>
      <Styled.EmbedScript {...embedScript} />
    </Space>
  );
};

export default Embed;
